import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ICity } from "../models/cities";

@Injectable({
  providedIn: "root",
})
export class CitiesService {
  public list: ICity[] = [];

  public listWithoutItaly: ICity[] = [];

  public baseurl: string = "/cities";

  constructor(private _httpClient: HttpClient) {}

  async getList() {
    return this._httpClient
      .get("/cities")
      .toPromise()
      .then((response: ICity[]) => {
        response = response.map((city: ICity) => {
          city.nice_name = city.name;
          if(city.initials.trim().length){
            city.nice_name += ` (${city.initials})`
          }
          return city;
        });
        this.list = response;
        this.listWithoutItaly = this.list.filter((item: ICity) => item.name.toLowerCase().trim() != "italia");
        return response;
      })
      .catch((err) => {
        console.error(err);
        return [];
      });
  }

  async get(id: number) {
    return this._httpClient.get<ICity>(this.baseurl + "/" + id).toPromise();
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseurl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async create(data: ICity) {
    return this._httpClient
      .post(this.baseurl, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: ICity) {
    return this._httpClient
      .put(this.baseurl + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }
}
